var render, staticRenderFns
import script from "./DelegationInfoView.vue?vue&type=script&lang=js&"
export * from "./DelegationInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d845351",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d845351')) {
      api.createRecord('6d845351', component.options)
    } else {
      api.reload('6d845351', component.options)
    }
    
  }
}
component.options.__file = "src/views/delegation-info/DelegationInfoView.vue"
export default component.exports